import axios from "axios";
import MainService from "./MainService";

export default class LoginService extends MainService {

    login(user) {
        const headers = {
            'Authorization': 'Basic Z3VpZGVfY2xpZW50OnNlY3JldA==',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        const data = new FormData();

        data.append('grant_type', 'password');
        data.append('username', user.email);
        data.append('password', user.password);

        return axios.post(this.apiUrl + '/oauth/token', data, { headers: headers });
    }
}



// WEBPACK FOOTER //
// ./src/service/LoginService.js